import { render, staticRenderFns } from "./FreemiumIcon.vue?vue&type=template&id=61be3772&scoped=true&"
import script from "./FreemiumIcon.vue?vue&type=script&lang=ts&"
export * from "./FreemiumIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FreemiumIcon.vue?vue&type=style&index=0&id=61be3772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be3772",
  null
  
)

export default component.exports